import { ForwarderPointStatuses } from '@modules/settings/types';

export const getTextViewStatus = (status?: ForwarderPointStatuses) => {
  return status?.Name || (status ? 'Статус №' + status?.ID : '');
};
